module.exports = __webpack_public_path__ + "static/assets/1980303ffc6f5c17c601a9e5992aea77.mp3";